// Route configurations with role permissions
export const routeConfigs = {
  dashboard: { roles: ["admin"] },
  orders: { roles: ["admin"] },
  products: { roles: ["admin"] },
  collections: { roles: ["admin"] },
  categories: { roles: ["admin"] },
  promotions: { roles: ["admin"] },
  customers: { roles: ["admin"] },
  users: { roles: ["admin"] },
  settings: { roles: ["admin"] },
  sections: { roles: ["admin"] },
  branches: { roles: ["admin"] },
  logs: { roles: ["admin"] },
  articles: { roles: ["admin"] }
};

export const monthMapping: { [key: string]: string } = {
  January: "Tháng 1",
  February: "Tháng 2",
  March: "Tháng 3",
  April: "Tháng 4",
  May: "Tháng 5",
  June: "Tháng 6",
  July: "Tháng 7",
  August: "Tháng 8",
  September: "Tháng 9",
  October: "Tháng 10",
  November: "Tháng 11",
  December: "Tháng 12",
};
